import { withStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
const styles = (theme) => ({
  activeReason: {
    color: theme.warningTextColorDispatch
  },
  notActiveReason: {
    color: theme.HeaderDefaultTextColor
  },
  reason: {
    fontSize: theme.textFontSize,
    display: 'flex',
    padding: '2px 0px',
    alignItems: 'center'
  },
  iconStyle: {
    paddingRight: 4,
    fontSize: theme.headerTextFontSize
  }
});
const ProExcludedReason = ({ excludedReasons, classes }) => {
  return (
    <div>
      {excludedReasons.map((reason, index) => {
        return (
          <div
            key={index}
            className={`${classes.reason} ${
              reason.isActive ? classes.activeReason : classes.notActiveReason
            }`}>
            <InfoIcon className={classes.iconStyle} />
            {reason.message}
          </div>
        );
      })}
    </div>
  );
};
export default withStyles(styles)(ProExcludedReason);
